/* Bionic Labs section scripts. Plain script, no build step. Safe to include more than once. */
(function () {
  'use strict';
  if (window.__blInit) return;
  window.__blInit = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* Iridescent sheen: map page scroll to --bl-shift (0–1) so gradients drift like a holographic label. */
  window.addEventListener('scroll', function () { document.documentElement.classList.toggle('bl-scrolled', window.scrollY > 24); }, { passive: true });
  if (!reduceMotion) {
    var shiftRaf = 0;
    var setShift = function () {
      shiftRaf = 0;
      var max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      var p = Math.min(1, Math.max(0, window.scrollY / max));
      document.documentElement.style.setProperty('--bl-shift', (p * 0.66).toFixed(4));
      document.documentElement.classList.toggle('bl-scrolled', window.scrollY > 24);
    };
    window.addEventListener('scroll', function () { if (!shiftRaf) shiftRaf = requestAnimationFrame(setShift); }, { passive: true });
    setShift();
  }

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function onReady(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  /* ------------------------------------------------------------------
     Cart: add, then let whichever cart drawer the theme has refresh.
     ------------------------------------------------------------------ */
  function addToCart(items, sourceId) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok) throw new Error(body.description || body.message || 'Could not add to cart');
          return body;
        });
      })
      .then(function () { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Vessel / Horizon components (cart bubble, cart items) listen for this.
        var ev = new Event('cart:update', { bubbles: true });
        ev.detail = { resource: cart, sourceId: sourceId || 'bl', data: { source: 'bl-section', itemCount: cart.item_count } };
        document.dispatchEvent(ev);
        document.dispatchEvent(new CustomEvent('bl:cart-added', { detail: { cart: cart } }));
        openCart();
        return cart;
      });
  }

  function openCart() {
    // The store's current custom drawer (.en-cd) listens for this event.
    if (document.querySelector('.en-cd')) {
      document.dispatchEvent(new CustomEvent('cart-drawer:open'));
      return;
    }
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
    window.location.href = root + 'cart';
  }

  function bindAddForm(form, opts) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = opts.button || form.querySelector('[type="submit"]');
      var idInput = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
      if (!idInput || !btn || btn.disabled) return;
      var qtyInput = form.querySelector('[name="quantity"]');
      var label = btn.querySelector('[data-bl-label]') || btn;
      var original = label.textContent;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      label.textContent = btn.getAttribute('data-adding') || 'Adding…';
      if (opts.message) { opts.message.textContent = ''; opts.message.classList.remove('is-error'); }
      addToCart([{ id: Number(idInput.value), quantity: qtyInput ? Math.max(1, Number(qtyInput.value) || 1) : 1 }], opts.sourceId)
        .then(function () {
          label.textContent = btn.getAttribute('data-added') || 'Added';
          setTimeout(function () { label.textContent = original; btn.disabled = false; btn.removeAttribute('aria-busy'); }, 1600);
        })
        .catch(function (err) {
          label.textContent = original;
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          if (opts.message) { opts.message.textContent = err.message; opts.message.classList.add('is-error'); }
        });
    });
  }

  /* ------------------------------------------------------------------
     Product page: tiers, price, sticky bar
     ------------------------------------------------------------------ */
  function initProduct(el) {
    var form = $('[data-bl-form]', el);
    if (!form) return;
    var atc = $('[data-bl-atc]', el);
    var msg = $('[data-bl-atc-msg]', el);
    var priceNow = $$('[data-bl-price]', el);
    var pricePer = $('[data-bl-price-per]', el);
    var priceSave = $('[data-bl-price-save]', el);
    var priceWas = $$('[data-bl-price-was]', el);
    var priceOff = $$('[data-bl-price-off]', el);
    var sticky = $('[data-bl-sticky]', el);
    var stickyBtn = sticky && $('[data-bl-sticky-atc]', sticky);

    function selected() { return form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]'); }

    function sync(pushUrl) {
      var input = selected();
      if (!input) return;
      var d = input.dataset;
      priceNow.forEach(function (p) { p.textContent = d.price; });
      if (pricePer) { pricePer.textContent = d.per || ''; pricePer.hidden = !d.per; }
      if (priceSave) { priceSave.textContent = d.save || ''; priceSave.hidden = !d.save; }
      priceWas.forEach(function (p) { p.textContent = d.was || ''; p.hidden = !d.was; });
      priceOff.forEach(function (p) { p.textContent = d.off || ''; p.hidden = !d.off; });
      var available = d.available === 'true';
      [atc, stickyBtn].forEach(function (b) {
        if (!b) return;
        b.disabled = !available;
        var l = b.querySelector('[data-bl-label]') || b;
        l.textContent = available ? b.getAttribute('data-label') : b.getAttribute('data-soldout');
      });
      $$('.bl-tier', el).forEach(function (t) { t.classList.toggle('is-selected', t.contains(input)); });
      if (pushUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        window.history.replaceState({}, '', url.toString());
      }
    }

    form.addEventListener('change', function (e) { if (e.target.name === 'id') sync(true); });
    sync(false);
    bindAddForm(form, { button: atc, message: msg, sourceId: el.id });

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(atc); else atc.click();
      });
    }
    if (sticky && atc && 'IntersectionObserver' in window) {
      var footer = document.querySelector('footer, .bl-footer, .shopify-section-group-footer-group');
      var atcVisible = true, footerVisible = false;
      var update = function () { sticky.classList.toggle('is-visible', !atcVisible && !footerVisible); sticky.setAttribute('aria-hidden', String(atcVisible || footerVisible)); };
      new IntersectionObserver(function (entries) { atcVisible = entries[0].isIntersecting; update(); }).observe(atc);
      if (footer) new IntersectionObserver(function (entries) { footerVisible = entries[0].isIntersecting; update(); }).observe(footer);
    }
  }

  /* ------------------------------------------------------------------
     Gallery
     ------------------------------------------------------------------ */
  function initGallery(el) {
    var track = $('[data-bl-slides]', el);
    if (!track) return;
    var slides = $$('[data-bl-slide]', el);
    var thumbs = $$('[data-bl-thumb]', el);
    var count = $('[data-bl-count]', el);
    var current = 0;
    function go(i) {
      current = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[current].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    function mark(i) {
      current = i;
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', String(n === i)); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    $$('[data-bl-nav]', el).forEach(function (b) {
      b.addEventListener('click', function () { go(current + (b.getAttribute('data-bl-nav') === 'next' ? 1 : -1)); });
    });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); });
    }, { passive: true });
    // The page keeps vertical scrolling on touch (touch-action: pan-y); only a clear sideways swipe changes the photo.
    var sx = null, sy = 0;
    track.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; sx = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 2) go(current + (dx < 0 ? 1 : -1));
    }, { passive: true });
    mark(0);
  }

  /* ------------------------------------------------------------------
     Dispatch cutoff countdown. Uses the store's real cutoff settings.
     ------------------------------------------------------------------ */
  function zonedParts(tz) {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: tz, weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date())
      .forEach(function (p) { parts[p.type] = p.value; });
    var days = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };
    return { dow: days[parts.weekday], h: Number(parts.hour), m: Number(parts.minute) };
  }
  function initDispatch(el) {
    var tz = el.getAttribute('data-tz') || 'Europe/Tallinn';
    var cutoff = Number(el.getAttribute('data-cutoff') || 14);
    var days = (el.getAttribute('data-days') || '1,2,3,4,5').split(',').map(Number);
    var out = $('[data-bl-dispatch-text]', el) || el;
    var tToday = el.getAttribute('data-today');
    var tNext = el.getAttribute('data-next');
    var lang = document.documentElement.lang || 'en';
    function render() {
      var now;
      try { now = zonedParts(tz); } catch (e) { return; }
      var minsLeft = cutoff * 60 - (now.h * 60 + now.m);
      if (days.indexOf(now.dow) > -1 && minsLeft > 0) {
        var h = Math.floor(minsLeft / 60), m = minsLeft % 60;
        out.innerHTML = tToday.replace('{time}', '<strong>' + (h ? h + 'h ' : '') + m + 'm</strong>');
        return;
      }
      for (var i = 1; i <= 7; i++) {
        var d = ((now.dow - 1 + i) % 7) + 1;
        if (days.indexOf(d) > -1) {
          var date = new Date(Date.now() + i * 86400000);
          var name = i === 1 ? (el.getAttribute('data-tomorrow') || 'tomorrow') : new Intl.DateTimeFormat(lang, { weekday: 'long', timeZone: tz }).format(date);
          out.innerHTML = tNext.replace('{day}', '<strong>' + name + '</strong>');
          return;
        }
      }
    }
    render();
    setInterval(render, 30000);
  }

  /* ------------------------------------------------------------------
     Chromatogram: drawn from the batch's reported purity.
     Main-peak area ≈ purity %, the rest split across small impurity peaks.
     ------------------------------------------------------------------ */
  function seeded(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); }
    return function () { h ^= h << 13; h ^= h >>> 17; h ^= h << 5; return ((h >>> 0) % 10000) / 10000; };
  }
  function drawChroma(svg) {
    var ns = 'http://www.w3.org/2000/svg';
    var W = 400, H = 170, base = 148, top = 14;
    var purity = Math.min(99.99, Math.max(50, parseFloat(svg.getAttribute('data-purity')) || 99));
    var rand = seeded(svg.getAttribute('data-seed') || 'bl');
    var mainT = 0.42 + rand() * 0.12, mainW = 0.011;
    var peaks = [{ t: mainT, h: 1, w: mainW }];
    var impArea = mainW * (100 - purity) / purity;
    var n = 4, weights = [], sum = 0;
    for (var k = 0; k < n; k++) { weights.push(0.3 + rand()); sum += weights[k]; }
    for (var j = 0; j < n; j++) {
      var t = 0.1 + rand() * 0.8;
      if (Math.abs(t - mainT) < 0.05) t += 0.08;
      var w = 0.006 + rand() * 0.006;
      peaks.push({ t: t, h: (impArea * weights[j] / sum) / w * 6, w: w }); // ×6 keeps trace peaks visible
    }
    function y(x) {
      var v = 0;
      for (var i = 0; i < peaks.length; i++) { var d = (x - peaks[i].t) / peaks[i].w; v += peaks[i].h * Math.exp(-0.5 * d * d); }
      v += 0.004 * Math.sin(x * 97) + 0.003 * Math.sin(x * 241);
      return base - Math.max(-0.01, v) * (base - top);
    }
    var d = '';
    for (var i = 0; i <= 400; i++) { var x = i / 400; d += (i ? 'L' : 'M') + (x * W).toFixed(1) + ' ' + y(x).toFixed(1); }
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    svg.innerHTML = '';
    for (var g = 0; g < 4; g++) {
      var gl = document.createElementNS(ns, 'line'), gy = top + g * (base - top) / 3;
      gl.setAttribute('x1', 0); gl.setAttribute('x2', W); gl.setAttribute('y1', gy); gl.setAttribute('y2', gy);
      gl.setAttribute('class', 'bl-chroma__grid');
      svg.appendChild(gl);
    }
    var area = document.createElementNS(ns, 'path');
    area.setAttribute('d', d + 'L' + W + ' ' + base + 'L0 ' + base + 'Z');
    area.setAttribute('class', 'bl-chroma__area');
    svg.appendChild(area);
    var line = document.createElementNS(ns, 'path');
    line.setAttribute('d', d);
    line.setAttribute('class', 'bl-chroma__line');
    svg.appendChild(line);
    var mins = svg.getAttribute('data-minutes') || '20';
    ['0', String(Math.round(mins / 2)), mins + ' min'].forEach(function (label, idx) {
      var tx = document.createElementNS(ns, 'text');
      tx.setAttribute('x', idx === 0 ? 2 : idx === 1 ? W / 2 : W - 2);
      tx.setAttribute('y', H - 4);
      tx.setAttribute('text-anchor', idx === 0 ? 'start' : idx === 1 ? 'middle' : 'end');
      tx.setAttribute('class', 'bl-chroma__axis');
      tx.textContent = label;
      svg.appendChild(tx);
    });
    var tag = document.createElementNS(ns, 'text');
    var tagX = mainT * W + 9;
    tag.setAttribute('x', tagX > W - 60 ? mainT * W - 9 : tagX);
    tag.setAttribute('text-anchor', tagX > W - 60 ? 'end' : 'start');
    tag.setAttribute('y', top + 10);
    tag.setAttribute('class', 'bl-chroma__tag');
    tag.textContent = purity.toFixed(purity % 1 ? 1 : 0) + '%';
    svg.appendChild(tag);
    if (!reduceMotion) {
      try { svg.style.setProperty('--len', Math.ceil(line.getTotalLength())); } catch (e) {}
    }
  }
  function initChroma(svg) {
    drawChroma(svg);
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      svg.classList.add('is-drawing');
      io.disconnect();
      // never leave the trace hidden if the animation is throttled (background tab, low-power mode)
      setTimeout(function () { svg.classList.remove('is-drawing'); }, 2600);
    }, { threshold: 0.4 });
    io.observe(svg);
  }

  /* ------------------------------------------------------------------
     Batch lookup (homepage block) and Lab Results filter
     ------------------------------------------------------------------ */
  function norm(s) { return String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function batchData(el) {
    var node = $('script[type="application/json"][data-bl-batches]', el) || $('script[type="application/json"][data-bl-batches]');
    try { return JSON.parse(node ? node.textContent : '[]'); } catch (e) { return []; }
  }
  function initLookup(el) {
    var form = $('[data-bl-lookup-form]', el);
    var input = $('[data-bl-lookup-input]', el);
    var panel = $('[data-bl-lookup-panel]', el);
    var tplHit = $('template[data-bl-hit]', el);
    var tplMiss = $('template[data-bl-miss]', el);
    var data = batchData(el);
    function show(code) {
      var key = norm(code);
      if (!key) return;
      var hit = null;
      for (var i = 0; i < data.length; i++) { if (norm(data[i].code) === key) { hit = data[i]; break; } }
      panel.innerHTML = '';
      if (!hit) {
        var miss = tplMiss.content.cloneNode(true);
        $$('[data-f="code"]', miss).forEach(function (n) { n.textContent = code.toUpperCase(); });
        panel.appendChild(miss);
        return;
      }
      var node = tplHit.content.cloneNode(true);
      $$('[data-f]', node).forEach(function (n) {
        var f = n.getAttribute('data-f');
        if (n.tagName === 'A') {
          if (hit[f]) n.setAttribute('href', hit[f]); else n.remove();
        } else {
          n.textContent = hit[f] || '—';
        }
      });
      panel.appendChild(node);
      var hdg = panel.querySelector('[tabindex="-1"]');
      if (hdg) hdg.focus({ preventScroll: true });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); show(input.value); });
    var q = new URLSearchParams(window.location.search).get('batch');
    if (q) { input.value = q; show(q); }
  }
  function initLab(el) {
    var input = $('[data-bl-lab-filter]', el);
    var body = $('[data-bl-lab-body]', el);
    var rows = $$('[data-bl-lab-body] [data-search]', el);
    // newest test first
    rows.sort(function (a, b) { return (b.getAttribute('data-date') || '').localeCompare(a.getAttribute('data-date') || ''); });
    if (body) rows.forEach(function (r) { body.insertBefore(r, $('[data-bl-lab-empty]', body) || null); });
    var count = $('[data-bl-lab-count]', el);
    var empty = $('[data-bl-lab-empty]', el);
    var tpl = count ? count.getAttribute('data-template') : '';
    function apply() {
      var q = norm(input.value), shown = 0;
      rows.forEach(function (r) {
        var hit = !q || norm(r.getAttribute('data-search')).indexOf(q) > -1;
        r.hidden = !hit;
        r.classList.toggle('is-hit', !!q && hit && norm(r.getAttribute('data-code')) === q);
        if (hit) shown++;
      });
      if (count) count.textContent = tpl.replace('__N__', shown);
      if (empty) empty.hidden = shown > 0;
    }
    input.addEventListener('input', apply);
    var q = new URLSearchParams(window.location.search).get('batch');
    if (q) {
      input.value = q; apply();
      var hit = $('.is-hit', el);
      if (hit) hit.scrollIntoView({ block: 'center' });
    } else apply();
  }

  /* ------------------------------------------------------------------
     Announcement bar
     ------------------------------------------------------------------ */
  function initAnnounce(el) {
    var msgs = $$('[data-bl-msg]', el);
    if (msgs.length < 2) return;
    var i = 0, paused = false, every = Number(el.getAttribute('data-interval') || 4500);
    el.addEventListener('mouseenter', function () { paused = true; });
    el.addEventListener('mouseleave', function () { paused = false; });
    el.addEventListener('focusin', function () { paused = true; });
    el.addEventListener('focusout', function () { paused = false; });
    setInterval(function () {
      if (paused || document.hidden) return;
      msgs[i].setAttribute('aria-hidden', 'true');
      i = (i + 1) % msgs.length;
      msgs[i].setAttribute('aria-hidden', 'false');
    }, every);
  }

  /* ------------------------------------------------------------------
     Related products (Shopify recommendations endpoint)
     ------------------------------------------------------------------ */
  function initRecs(el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-bl-recs]');
      if (fresh && fresh.querySelector('.bl-card')) {
        el.innerHTML = fresh.innerHTML;
        el.hidden = false;
        init(el);
      }
    }).catch(function () {});
  }

  /* ------------------------------------------------------------------ */
  /* ------------------------------------------------------------------
     Motion: reveal on scroll, hero intro, number count-up, card cursor sheen
     ------------------------------------------------------------------ */
  var RV = [
    '.bl-section .bl-head', '.bl-section .bl-eyebrow', '.bl-section .bl-h2', '.bl-section .bl-lede',
    '.bl-grid > *', '.bl-steps > *', '.bl-area', '.bl-acc__item', '.bl-compare',
    '.bl-person', '.bl-manifesto > *', '.bl-story__copy > *', '[data-bl-chatmock]', '.bl-coa', '.bl-channel', '.bl-contact__company', '.bl-contact__form', '.bl-track__card', '.bl-story__media', '.bl-strip__item', '.bl-proofbar__item', '.bl-trust__item', '.bl-review', '.bl-lab', '.bl-news'
  ].join(',');
  var revealIO = null;
  function countUp(el) {
    var m = /^\s*(\d+(?:\.(\d+))?)(\s*%?)\s*$/.exec(el.textContent);
    if (!m || el.__blCounted) return;
    el.__blCounted = true;
    var to = parseFloat(m[1]), dp = m[2] ? m[2].length : 0, from = Math.max(0, to - 12), t0 = null;
    function step(t) {
      if (!t0) t0 = t;
      var k = Math.min(1, (t - t0) / 1400), e = 1 - Math.pow(1 - k, 4);
      el.textContent = (from + (to - from) * e).toFixed(dp) + m[3];
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function initMotion(scope) {
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('bl-motion');
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('is-in');
          // cards in a horizontal scroller may never cross the viewport: reveal the whole row together
          if (en.target.parentElement && en.target.parentElement.matches('.bl-grid, .bl-strip')) {
            Array.prototype.forEach.call(en.target.parentElement.children, function (c) { c.classList.add('is-in'); revealIO.unobserve(c); });
          }
          $$('.is-pass, .bl-batchmini__purity, .bl-readout__value--pass', en.target).forEach(countUp);
          revealIO.unobserve(en.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }
    $$(RV, scope).forEach(function (el) {
      if (el.hasAttribute('data-bl-rv') || el.closest('.bl-hero__copy') || (el.parentElement.closest('.bl-story__copy') && el.matches('.bl-eyebrow, .bl-h2, .bl-lede')) || el.parentElement.closest('[data-bl-rv]')) return;
      var sibs = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.setAttribute('data-bl-rv', '');
      el.style.setProperty('--bl-i', Math.min(sibs, 8));
      revealIO.observe(el);
    });
    $$('.bl-hero', scope).forEach(function (h) {
      $$('.bl-hero__copy > *', h).forEach(function (c, i) {
        c.setAttribute('data-bl-rv', ''); c.style.setProperty('--bl-i', i + (c.classList.contains('bl-display') ? 0 : 2));
      });
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        h.classList.add('is-in');
        $$('[data-bl-rv]', h).forEach(function (c) { c.classList.add('is-in'); });
        setTimeout(function () { $$('.is-pass', h).forEach(countUp); }, 700);
      }); });
    });
    // never leave content hidden if the observer is throttled
    setTimeout(function () { $$('[data-bl-rv]:not(.is-in)', scope).forEach(function (el) {
      var r = el.getBoundingClientRect(); if (r.top < window.innerHeight) el.classList.add('is-in');
    }); }, 2500);
    $$('.bl-card', scope).forEach(function (card) {
      var media = $('.bl-card__media', card);
      if (!media) return;
      card.addEventListener('pointermove', function (e) {
        var r = media.getBoundingClientRect();
        media.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        media.style.setProperty('--my', (e.clientY - r.top) + 'px');
      });
    });
  }

  /* ------------------------------------------------------------------
     WhatsApp pop-up: once per visit, N seconds after the visitor entered the site
     (timed across page views); closing it hides it for 3 days.
     ------------------------------------------------------------------ */
  function store(kind) { try { return window[kind]; } catch (e) { return null; } }
  function initWaNudge(el) {
    if (el.__blWa) return; el.__blWa = true;
    var ls = store('localStorage'), ss = store('sessionStorage');
    var delay = (parseInt(el.getAttribute('data-delay'), 10) || 60) * 1000;
    var now = Date.now(), entered = now;
    try {
      if (ls && Number(ls.getItem('bl-wa-dismissed') || 0) > now) return;
      if (ss && ss.getItem('bl-wa-shown')) return;
      entered = Number(ss && ss.getItem('bl-wa-entered')) || now;
      if (ss) ss.setItem('bl-wa-entered', String(entered));
    } catch (e) {}
    var btn = $('.bl-wa');
    function close(remember) {
      el.classList.remove('is-open'); el.classList.add('is-closing');
      setTimeout(function () { el.hidden = true; el.classList.remove('is-closing'); }, reduceMotion ? 0 : 260);
      if (remember) { try { ls && ls.setItem('bl-wa-dismissed', String(Date.now() + 3 * 864e5)); } catch (e) {} }
    }
    function open() {
      if (window.matchMedia && window.matchMedia('(max-width: 599px)').matches) return;   // phones: the floating button's label does this job
      if (btn && document.documentElement.classList.contains('bl-wa-gate') && !btn.classList.contains('is-shown')) { setTimeout(open, 2000); return; }
      if (document.hidden) { document.addEventListener('visibilitychange', function v() { if (!document.hidden) { document.removeEventListener('visibilitychange', v); open(); } }); return; }
      el.hidden = false; el.classList.add('is-open');
      if (btn && !reduceMotion) btn.classList.add('is-pulse');
      try { ss && ss.setItem('bl-wa-shown', '1'); } catch (e) {}
    }
    $('[data-bl-wa-close]', el).addEventListener('click', function () { close(true); });
    $('.bl-wa-nudge__body', el).addEventListener('click', function () { close(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !el.hidden) close(true); });
    setTimeout(open, Math.max(0, entered + delay - now));
  }

  function initTrack(form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var n = (form.elements.n.value || '').replace(/\s+/g, '').toUpperCase();
      if (!n) return;
      window.open((form.getAttribute('data-url') || '').replace('__N__', encodeURIComponent(n)), '_blank', 'noopener');
    });
  }

  /* ------------------------------------------------------------------
     Cookie consent: small card wired to Shopify's Customer Privacy API.
     Shows only where Shopify says a banner is needed and no choice exists yet.
     ------------------------------------------------------------------ */
  function initConsent(el) {
    if (el.__blConsent) return; el.__blConsent = true;
    var prefs = $('[data-bl-consent-prefs]', el);
    var toggle = $('[data-bl-consent-toggle]', el);
    var save = $('[data-bl-consent-save]', el);
    var boxes = $$('[data-bl-consent-kind]', el);
    function api() { return window.Shopify && window.Shopify.customerPrivacy; }
    function open(withPrefs) {
      var cp = api();
      if (cp && cp.currentVisitorConsent) {
        var c = cp.currentVisitorConsent() || {};
        boxes.forEach(function (b) { b.checked = c[b.getAttribute('data-bl-consent-kind')] === 'yes'; });
      }
      showPrefs(!!withPrefs);
      el.hidden = false; el.classList.remove('is-closing'); el.classList.add('is-open');
    }
    function close() {
      el.classList.remove('is-open'); el.classList.add('is-closing');
      setTimeout(function () { el.hidden = true; el.classList.remove('is-closing'); }, reduceMotion ? 0 : 260);
    }
    function showPrefs(on) {
      prefs.hidden = !on; save.hidden = !on; toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
    var ls = store('localStorage');
    function remembered() { try { return ls && Number(ls.getItem('bl-consent-at') || 0) > Date.now() - 180 * 864e5; } catch (e) { return false; } }
    function set(analytics, marketing) {
      try { ls && ls.setItem('bl-consent-at', String(Date.now())); } catch (e) {}
      var cp = api();
      var consent = {analytics: analytics, marketing: marketing, preferences: analytics, sale_of_data: marketing};
      if (cp && cp.setTrackingConsent) {
        try { cp.setTrackingConsent(consent, function () {}); } catch (e) {}
      }
      close();
    }
    $('[data-bl-consent-accept]', el).addEventListener('click', function () { set(true, true); });
    $('[data-bl-consent-decline]', el).addEventListener('click', function () { set(false, false); });
    save.addEventListener('click', function () {
      var v = {};
      boxes.forEach(function (b) { v[b.getAttribute('data-bl-consent-kind')] = b.checked; });
      set(!!v.analytics, !!v.marketing);
    });
    toggle.addEventListener('click', function () { showPrefs(prefs.hidden); });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-bl-consent-open]')) { e.preventDefault(); open(true); }
    });
    // Shopify's own cookie banner (Settings → Customer privacy) wins while it is switched on, so visitors are never asked twice.
    function shopifyBanner() { return document.getElementById('shopify-pc__banner') || document.querySelector('[id^="shopify-pc__"]'); }
    function decide() {
      var cp = api();
      if (remembered()) return;                                         // asked once already (kept for 6 months)
      if (!(cp && cp.shouldShowBanner && cp.shouldShowBanner())) return;
      setTimeout(function () {
        if (shopifyBanner()) return;
        var c = api(); if (c && c.shouldShowBanner && !c.shouldShowBanner()) return;
        open(false);
      }, 1500);
    }
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (err) { if (!err) decide(); });
    }
  }

  /* Press "/" anywhere to jump to the header search. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== '/' || e.metaKey || e.ctrlKey || e.altKey) return;
    var t = e.target; if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
    var q = document.querySelector('.bl-hsearch__input');
    if (q && q.getClientRects().length) { e.preventDefault(); q.focus(); }
  });

  /* Product descriptions: drop the old embedded structure / badge images and their captions
     (the page now shows its own structure drawing). */
  function cleanDesc(el) {
    $$('img', el).forEach(function (img) { var b = img.closest('p, h1, h2, h3, h4, h5, h6, figure, div:not([data-bl-desc])') || img; b.remove(); });
    $$('p, h1, h2, h3, h4, h5, h6, strong', el).forEach(function (n) {
      var t = (n.textContent || '').replace(/\s+/g, ' ').trim();
      if (/^[A-Za-z0-9 .+\-()]{0,40}structure$/i.test(t) || /^molecular (formula|weight)/i.test(t)) {
        var b = n.closest('p, h1, h2, h3, h4, h5, h6') || n; b.remove();
      }
    });
  }

  /* Catalogue: search, in-stock filter and sort, all client-side */
  function initCatalog(el) {
    var grid = $('[data-bl-cat-grid]', el); if (!grid) return;
    var items = $$('.bl-catalog__item', grid);
    var q = $('[data-bl-cat-q]', el), sort = $('[data-bl-cat-sort]', el), count = $('[data-bl-cat-count]', el), empty = $('[data-bl-cat-empty]', el);
    var avail = 'all';
    function apply() {
      var t = (q.value || '').toLowerCase().trim(), shown = 0;
      items.forEach(function (it) {
        var ok = (!t || it.getAttribute('data-title').indexOf(t) > -1) && (avail === 'all' || it.getAttribute('data-avail') === '1');
        it.hidden = !ok; if (ok) shown++;
      });
      var by = sort.value, num = function (it, k) { return parseFloat(it.getAttribute(k)) || 0; };
      var sorted = items.slice().sort(function (a, b) {
        if (by === 'az') return a.getAttribute('data-title').localeCompare(b.getAttribute('data-title'));
        if (by === 'price-asc') return num(a, 'data-price') - num(b, 'data-price');
        if (by === 'price-desc') return num(b, 'data-price') - num(a, 'data-price');
        if (by === 'purity') return num(b, 'data-purity') - num(a, 'data-purity');
        return num(a, 'data-i') - num(b, 'data-i');
      });
      sorted.forEach(function (it) { grid.appendChild(it); });
      if (count) count.textContent = shown + (shown === 1 ? ' product' : ' products');
      if (empty) empty.hidden = shown > 0;
    }
    q.addEventListener('input', apply); sort.addEventListener('change', apply);
    $$('[data-bl-cat-avail]', el).forEach(function (b) {
      b.addEventListener('click', function () {
        avail = b.getAttribute('data-bl-cat-avail');
        $$('[data-bl-cat-avail]', el).forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        apply();
      });
    });
    apply();
  }

  /* ------------------------------------------------------------------
     Floating WhatsApp button: appears once the visitor has scrolled past the
     verification steps (or one screen on pages without them). On phones it shows
     "Speak with a real person" first, then slides into the round logo.
     Once shown, it stays visible on the next pages of the visit.
     ------------------------------------------------------------------ */
  function initWaFloat(btn) {
    if (btn.__blWaF) return; btn.__blWaF = true;
    var ss = store('sessionStorage'), root = document.documentElement;
    var phone = function () { return window.matchMedia && window.matchMedia('(max-width: 599px)').matches; };
    var seen = false; try { seen = !!(ss && ss.getItem('bl-wa-on')); } catch (e) {}
    root.classList.add('bl-wa-gate');
    function show(first) {
      btn.classList.add('is-shown');
      if (!phone()) return;
      if (!first) { btn.classList.add('is-compact'); return; }
      setTimeout(function () { btn.classList.add('is-compact'); }, 4000);
    }
    if (seen) { show(false); return; }
    var after = btn.getAttribute('data-bl-wa-after'), raf = 0;
    function passed() {
      var t = after && document.querySelector(after);
      if (t) return t.getBoundingClientRect().bottom < window.innerHeight * 0.85;
      return (window.scrollY || document.documentElement.scrollTop) > window.innerHeight;
    }
    function check() {
      raf = 0;
      if (!passed()) return;
      window.removeEventListener('scroll', ask);
      try { ss && ss.setItem('bl-wa-on', '1'); } catch (e) {}
      show(true);
    }
    function ask() { if (!raf) raf = requestAnimationFrame(check); }
    window.addEventListener('scroll', ask, { passive: true });
    check();
  }

  function init(scope) {
    initMotion(scope);
    $$('[data-bl-wa]', scope).forEach(initWaFloat);
    $$('[data-bl-wa-nudge]', scope).forEach(initWaNudge);
    $$('[data-bl-desc]', scope).forEach(cleanDesc);
    $$('[data-bl-catalog]', scope).forEach(initCatalog);
    $$('form[data-bl-track]', scope).forEach(initTrack);
    $$('[data-bl-consent]', scope).forEach(initConsent);
    $$('[data-bl-product]', scope).forEach(initProduct);
    $$('[data-bl-gallery]', scope).forEach(initGallery);
    $$('[data-bl-dispatch]', scope).forEach(initDispatch);
    $$('svg[data-bl-chroma]', scope).forEach(initChroma);
    $$('[data-bl-lookup]', scope).forEach(initLookup);
    $$('[data-bl-lab]', scope).forEach(initLab);
    $$('[data-bl-announce]', scope).forEach(initAnnounce);
    $$('[data-bl-recs][data-url]', scope).forEach(initRecs);
    $$('form[data-bl-quick-add]', scope).forEach(function (f) { bindAddForm(f, { sourceId: 'bl-card' }); });
  }

  window.BL = { init: init, addToCart: addToCart, openCart: openCart };
  onReady(function () { init(document); });
  // Re-init sections when edited in the theme editor.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Our process slider: arrows, dots and swipe (scroll-snap) */
(function () {
  function init(root) {
    var track = root.querySelector('[data-bl-proc-track]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-bl-proc-dots] button'));
    var n = track.children.length;
    var idx = function () { return Math.round(track.scrollLeft / track.clientWidth); };
    var go = function (i) { i = (i + n) % n; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); };
    var mark = function () { var i = idx(); dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); }); };
    root.querySelector('[data-bl-proc-prev]').addEventListener('click', function () { go(idx() - 1); });
    root.querySelector('[data-bl-proc-next]').addEventListener('click', function () { go(idx() + 1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
    mark();
  }
  var run = function () { document.querySelectorAll('[data-bl-proc]:not([data-bl-ready])').forEach(function (r) { r.setAttribute('data-bl-ready', ''); init(r); }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* Room grid behind a section ([data-bl-room]): rays from a back wall to the edges plus depth frames,
   in solid pre-blended colours so it stays faint everywhere. Static, redrawn on resize. */
(function () {
  var NS = 'http://www.w3.org/2000/svg';
  function node(p, n, a) { var e = document.createElementNS(NS, n); for (var k in a) e.setAttribute(k, a[k]); p.appendChild(e); return e; }
  function draw(sec, svg) {
    // extend the grid up behind the proof bar when it sits right above this section
    var sr = sec.getBoundingClientRect(), bar = document.querySelector('.bl-proofbar'), lift = 0;
    var bb = bar && bar.getBoundingClientRect();
    if (bb && bb.height && sr.top - bb.bottom < 120 && sr.top >= bb.top) lift = Math.max(0, sr.top - bb.top);
    svg.style.top = (-lift) + 'px'; svg.style.height = 'calc(100% + ' + lift + 'px)';
    var r = svg.getBoundingClientRect(), W = r.width, H = r.height;
    svg.innerHTML = '';
    if (W < 10 || H < 10) return;
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    var light = document.documentElement.classList.contains('bl-light');
    var bgc = getComputedStyle(document.body).backgroundColor.match(/\d+(\.\d+)?/g) || [255, 255, 255];
    var bg = [+bgc[0], +bgc[1], +bgc[2]], ink = light ? [11, 24, 56] : [255, 255, 255];
    var A = light ? 0.085 : 0.1;
    var mix = function (a) { return 'rgb(' + [0, 1, 2].map(function (j) { return Math.round(bg[j] + (ink[j] - bg[j]) * a); }).join(',') + ')'; };
    var defs = node(svg, 'defs', {}), far = Math.max(W, H) * 2, id = 0, i;
    var narrow = W < 600;                                              // phones: wider, flatter back wall, fewer lines
    if (narrow) {
      var cx = W / 2, cy = H * 0.46, bw = W * 0.56, bh = H * 0.17;     // back wall
      var x0 = cx - bw / 2, y0 = cy - bh / 2, y1 = cy + bh / 2;
      var phoneRay = function (px, py) {
        var dx = px - cx, dy = py - cy, len = Math.sqrt(dx * dx + dy * dy) || 1;
        var ex = cx + dx / len * far, ey = cy + dy / len * far;
        var g = node(defs, 'linearGradient', { id: 'blRoom' + (++id), gradientUnits: 'userSpaceOnUse', x1: px, y1: py, x2: cx + dx * 3.2, y2: cy + dy * 3.2 });
        node(g, 'stop', { offset: 0, 'stop-color': mix(0) });
        node(g, 'stop', { offset: 1, 'stop-color': mix(A) });
        node(svg, 'line', { x1: px.toFixed(1), y1: py.toFixed(1), x2: ex.toFixed(1), y2: ey.toFixed(1), stroke: 'url(#blRoom' + id + ')' });
      };
      for (i = 0; i <= 6; i++) { var x = x0 + bw * i / 6; phoneRay(x, y0); phoneRay(x, y1); }
      // depth frames: only the floor and ceiling lines; the sides are too narrow to read
      for (i = 0; i < 7; i++) {
        var f = 1 / (1 - i * 0.12), w = bw * f, h = bh * f, st = mix(A * Math.min(1, 0.12 + i * 0.13));
        if (w > W * 1.6 && h > H * 1.6) break;
        [cy - h / 2, cy + h / 2].forEach(function (yy) { node(svg, 'line', { x1: (cx - w / 2).toFixed(1), y1: yy.toFixed(1), x2: (cx + w / 2).toFixed(1), y2: yy.toFixed(1), stroke: st }); });
      }
      return;
    }
    // Desktop: the room is built on the page's own layout. Its front frame runs along the proof bar and the
    // outer card edges, rays pass through the bar dividers and card gaps, and the lines use the site's hairline colour.
    var wrapEl = sec.querySelector('.bl-wrap'), edge = lift ? bb : (wrapEl || sec).getBoundingClientRect();
    var cards = [].slice.call(sec.querySelectorAll('.bl-grid > *')).map(function (c) { return c.getBoundingClientRect(); });
    var L = edge.left - r.left, R = edge.right - r.left, T = lift ? bb.bottom - r.top : 0;
    var B = cards.length ? Math.max.apply(null, cards.map(function (c) { return c.bottom; })) - r.top : H * 0.9;
    var vx = (L + R) / 2, vy = (T + B) / 2, BACK = 0.42;               // vanishing point, back wall scale
    var lc = (bar ? getComputedStyle(bar).borderTopColor : '').match(/\d+(\.\d+)?/g);
    var tint = function (a) {
      if (!lc) return mix(A * a);
      return 'rgb(' + [0, 1, 2].map(function (j) { return Math.round(bg[j] + (lc[j] - bg[j]) * a); }).join(',') + ')';
    };
    function ray(px, py) {
      var bx = vx + (px - vx) * BACK, by = vy + (py - vy) * BACK;
      var g = node(defs, 'linearGradient', { id: 'blRoom' + (++id), gradientUnits: 'userSpaceOnUse', x1: bx, y1: by, x2: px, y2: py });
      node(g, 'stop', { offset: 0, 'stop-color': tint(0) });
      node(g, 'stop', { offset: 1, 'stop-color': tint(1) });
      node(svg, 'line', { x1: bx.toFixed(1), y1: by.toFixed(1), x2: (vx + (px - vx) * 4).toFixed(1), y2: (vy + (py - vy) * 4).toFixed(1), stroke: 'url(#blRoom' + id + ')' });
    }
    // anchor points: cell and card edges, plus the middle of each
    var between = function (xs) { var o = xs.slice(); for (var k = 1; k < xs.length; k++) o.push((xs[k - 1] + xs[k]) / 2); return o; };
    var gaps = [L];
    cards.forEach(function (c, k) {
      var n = cards[k + 1], gx = n && n.left > c.right ? (c.right + n.left) / 2 - r.left : null;
      if (gx !== null && gx > L && gx < R) gaps.push(gx);
    });
    gaps.push(R);
    var cells = [L];
    if (lift) [].slice.call(bar.children).forEach(function (c) { var cxr = c.getBoundingClientRect().right - r.left; if (cxr > L + 1 && cxr < R - 1) cells.push(cxr); });
    cells.push(R);
    between(cells.length > 2 ? cells : gaps).forEach(function (x) { ray(x, T); });
    between(gaps).forEach(function (x) { ray(x, B); });
    for (i = 1; i < 4; i++) { var sy = T + (B - T) * i / 4; ray(L, sy); ray(R, sy); }
    // depth frames, receding from the front frame to the back wall
    [0.78, 0.64, 0.54, 0.47, BACK].forEach(function (s) {
      node(svg, 'rect', { x: (vx + (L - vx) * s).toFixed(1), y: (vy + (T - vy) * s).toFixed(1), width: ((R - L) * s).toFixed(1), height: ((B - T) * s).toFixed(1), fill: 'none', stroke: tint(0.15 + (s - BACK) / (1 - BACK) * 0.7) });
    });
    // front frame: no top edge under the proof bar, whose own border is that line
    [[L, T, L, B], [R, T, R, B], [L, B, R, B]].concat(lift ? [] : [[L, T, R, T]]).forEach(function (q) {
      node(svg, 'line', { x1: q[0].toFixed(1), y1: q[1].toFixed(1), x2: q[2].toFixed(1), y2: q[3].toFixed(1), stroke: tint(1) });
    });
  }
  function init(sec) {
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('class', 'bl-room__grid'); svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false');
    svg.setAttribute('preserveAspectRatio', 'none');
    sec.insertBefore(svg, sec.firstChild);
    var raf = 0, redraw = function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { draw(sec, svg); }); };
    redraw();
    if (window.ResizeObserver) new ResizeObserver(redraw).observe(sec); else window.addEventListener('resize', redraw);
  }
  var run = function () { document.querySelectorAll('[data-bl-room]:not([data-bl-ready])').forEach(function (r) { r.setAttribute('data-bl-ready', ''); init(r); }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* Product page delivery estimate: order day -> dispatch-by date -> delivery window, in business days (store timezone). */
(function () {
  function init(el) {
    var tz = el.getAttribute('data-tz') || 'Europe/Tallinn';
    var cutoff = Number(el.getAttribute('data-cutoff') || 14);
    var work = (el.getAttribute('data-days') || '1,2,3,4,5').split(',').map(Number);
    var ship = Number(el.getAttribute('data-ship-days') || 2), min = Number(el.getAttribute('data-min') || 1), max = Number(el.getAttribute('data-max') || 3);
    var p = {};
    try {
      new Intl.DateTimeFormat('en-GB', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    } catch (e) { return; }
    var day = new Date(Date.UTC(+p.year, +p.month - 1, +p.day, 12));          // calendar date in the store's timezone
    var iso = function (d) { var w = d.getUTCDay(); return w === 0 ? 7 : w; };
    var isWork = function (d) { return work.indexOf(iso(d)) > -1; };
    var next = function (d) { return new Date(d.getTime() + 86400000); };
    var addWork = function (d, n) { while (n > 0) { d = next(d); if (isWork(d)) n--; } return d; };
    var start = day, today = true;
    if (!isWork(day) || +p.hour >= cutoff) { today = false; do { start = next(start); } while (!isWork(start)); }
    var shipBy = addWork(start, ship), from = addWork(shipBy, min), to = addWork(shipBy, max);
    var fmt = function (d) { return new Intl.DateTimeFormat('en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }).format(d); };
    var set = function (sel, txt) { var n = el.querySelector(sel); if (n) n.textContent = txt; };
    set('[data-eta-order]', today ? 'Today' : fmt(start));
    set('[data-eta-ship]', 'By ' + fmt(shipBy));
    set('[data-eta-deliver]', fmt(from) + ' – ' + fmt(to));
    el.classList.add('is-ready');
  }
  var run = function () { document.querySelectorAll('[data-bl-eta]:not([data-bl-ready])').forEach(function (e) { e.setAttribute('data-bl-ready', ''); init(e); }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* Verification steps: a line that runs through the steps as the page scrolls, lighting each step it reaches. */
(function () {
  function init(ol) {
    var steps = [].slice.call(ol.querySelectorAll('.bl-step')), raf = 0;
    var update = function () {
      raf = 0;
      var r = ol.getBoundingClientRect(), vh = window.innerHeight, vertical = getComputedStyle(ol).gridTemplateColumns.split(' ').length < 2;
      var p = vertical ? (vh * 0.62 - r.top) / r.height : (vh * 0.85 - r.top) / (vh * 0.45);
      p = Math.max(0, Math.min(1, p));
      ol.style.setProperty('--p', p.toFixed(4));
      steps.forEach(function (s, i) {
        var at = vertical ? (s.offsetTop + 28) / r.height : (i + 0.15) / steps.length;
        s.classList.toggle('is-on', p >= at);
      });
    };
    var ask = function () { if (!raf) raf = requestAnimationFrame(update); };
    window.addEventListener('scroll', ask, { passive: true });
    window.addEventListener('resize', ask);
    update();
  }
  var run = function () { document.querySelectorAll('[data-bl-steps]:not([data-bl-ready])').forEach(function (r) { r.setAttribute('data-bl-ready', ''); init(r); }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* Founders photo: switch between two photos. */
(function () {
  function init(box) {
    var slides = box.querySelectorAll('.bl-founders__slide'), btns = box.querySelectorAll('.bl-founders__tabs button');
    var show = function (n) {
      slides.forEach(function (s) { var on = s.getAttribute('data-i') == n; s.classList.toggle('is-on', on); s.setAttribute('aria-hidden', on ? 'false' : 'true'); });
      btns.forEach(function (b) { var on = b.getAttribute('data-i') == n; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
    };
    btns.forEach(function (b) { b.addEventListener('click', function () { show(b.getAttribute('data-i')); }); });
    var x0 = null;
    box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) show(dx < 0 ? 1 : 0);
    });
  }
  var run = function () { document.querySelectorAll('[data-bl-swap]:not([data-bl-ready])').forEach(function (r) { r.setAttribute('data-bl-ready', ''); init(r); }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
